import {Component, Injector, OnInit} from "@angular/core";
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {BaseComponentDirective} from "../../_shared/base/base.component";
import {UserService} from "../dashboard/services/user.service";
import {AdminService} from "../dashboard/services/admin.service";
import {ParameterService} from "../../_services/parameter.service";
import {AssociationService} from "../associactions/services/association.service";
import {MatSnackBar} from "@angular/material/snack-bar";
import {BehaviorSubject} from "rxjs";
import {ConfirmationDialog} from "../../_shared/dialog/confirmation.dialog";

@Component({
    selector: 'app-stepper-ceu',
    templateUrl: './stepper-ceu.component.html',
    styleUrls: ['./my-wallet.component.scss']
})
export class StepperCeuComponent extends BaseComponentDirective implements OnInit {
    firstFormGroup: FormGroup;
    secondFormGroup: FormGroup;
    thirdFormGroup: FormGroup;

    public documentTypes: any = {};
    public certifications: any[] = [];
    public documentId: number;
    public data: any = {};

    fileUrl: string | ArrayBuffer;
    fd: FormData;
    uploading = false;

    private myActivities = new BehaviorSubject<any[]>([]);
    activityList: any[] = [];
    activities = this.myActivities.asObservable();
    validationCheck = {
        id: '',
        result: '',
        score: 0
    }

    mode = 'new';

    constructor(
        injector: Injector,
        private formBuilder: FormBuilder,
        private userService: UserService,
        private adminService: AdminService,
        private parameterService: ParameterService,
        private associationService: AssociationService,
        private snackbar: MatSnackBar
    ) {
        super(injector);
        this.firstFormGroup = this.formBuilder.group({
            certification: [null, Validators.required],
            documentType: [null, Validators.required],
            activity: [null, [Validators.required]],
            earnedCredit: [null],
        });
        this.secondFormGroup = this.formBuilder.group({
            secondCtrl: ['']
        });
        this.thirdFormGroup = this.formBuilder.group({
            thirdCtrl: ['', Validators.required]
        });
    }

    override async ngOnInit(): Promise<void> {
        super.ngOnInit();

        if(this.activatedRoute.snapshot.params.id) {
            this.mode = 'edit';
            this.documentId = this.activatedRoute.snapshot.params.id;
        }

        this.firstFormGroup.controls.certification.valueChanges.subscribe(async r => {

            let cert = this.certifications.find(c => c.id == r);
            if(cert) {
                this.activityList = await this.associationService.getActivitiesByProviderIdNoPaging(cert.association.id);
                this.myActivities.next(this.activityList);
            }


        });


        this.userService.getUserCertificationList().then(async r => {
            this.certifications = r;
            this.documentTypes = await this.parameterService.getParameterByName("DOCUMENT_TYPE");
            if(this.mode == 'edit') {
                this.userService.getUserCEUById(this.documentId).then(d => {
                    console.log(d);
                    this.data = d;
                    this.firstFormGroup.controls.certification.setValue(this.data.certification.id);
                    console.log(this.data.certification.id);
                    this.firstFormGroup.controls.documentType.setValue(this.data.document.documentType);
                    this.firstFormGroup.controls.activity.setValue(this.data.document.providerActivityId);
                    this.firstFormGroup.controls.earnedCredit.setValue(this.data.document.earnedCredit);
                });

            }
        });

    }

    onReset(stepper: any) {
        stepper.reset();
        this.firstFormGroup.reset();
        this.secondFormGroup.reset();
        this.thirdFormGroup.reset();
    }

    goBack() {
        this.router.navigate(['/my-wallet'], {queryParams: {tab: 'ceus'}}).then();
    }

    getFileChange($event: FileList): void {
        this.fd = new FormData();
        const fileTransfer = $event[0];
        this.fd.append('file', fileTransfer);
    }

    getValidationCheckResult($event: any) {
        this.firstFormGroup.controls.earnedCredit.setValue($event.score);
        this.validationCheck.result = JSON.stringify($event);
    }

    save() {
        const screenWidth = window.innerWidth;
        const dialogWidth = screenWidth < 768 ? '90vw' : '500px';
        const dialog = this.dialog.open(ConfirmationDialog, {
            width: dialogWidth,
            maxWidth: '100%',
            data: {
                message: `Are you sure want save this CEU?`,
                buttonCancelLabel: 'Cancel',
                buttonOkLabel: 'Yes, Save'
            }
        });

        dialog.componentInstance.result.subscribe(r => {
            if(r) {
                this.onSave();
            }
        })
    }

    onSave() {
        this.uploading = true;
        const validation = this.check(this.firstFormGroup);
        this.firstFormGroup.disable();
        if(validation) {
            this.showAlert('Warning', 'Please fill all required input', '');
            this.uploading = false;
            this.firstFormGroup.enable();
            return;
        }

        if(!this.fd) {
            this.showAlert('Warning', 'please add a PDF or image file of your certification', '');
            this.firstFormGroup.enable();
            this.uploading = false;
            return;
        }

        if(this.validationCheck.result == '') {
            this.showAlertDark('Warning', 'please answer all activity conditions', '');
            this.uploading = false;
            this.firstFormGroup.enable();
            return;
        }

        if(this.mode == 'edit') {
            this.validationCheck.score = this.firstFormGroup.controls.earnedCredit.value;
            this.userService.updateFile(
                this.fd,
                this.documentId,
                this.firstFormGroup.controls.certification.value,
                this.firstFormGroup.controls.documentType.value,
                this.firstFormGroup.controls.activity.value,
                this.validationCheck
            ).then(_ => {
                this.snackbar.open('Your CEU document has been added successfully', null, {
                    duration: 3000,
                    verticalPosition: 'bottom',
                    horizontalPosition: 'center'
                });
                this.uploading = false;
                this.router.navigate(['/my-wallet'], {queryParams: {tab: 'ceus'}}).then();
            });

        } else {
            this.validationCheck.score = this.firstFormGroup.controls.earnedCredit.value;
            this.userService.uploadFile(
                this.fd,
                this.firstFormGroup.controls.certification.value,
                this.firstFormGroup.controls.documentType.value,
                this.firstFormGroup.controls.activity.value,
                this.validationCheck
            ).then(_ => {
                this.snackbar.open('Your CEU document has been added successfully', null, {
                    duration: 3000,
                    verticalPosition: 'bottom',
                    horizontalPosition: 'center'
                });
                this.uploading = false;
                this.router.navigate(['/my-wallet'], {queryParams: {tab: 'ceus'}}).then();
            });

        }

    }
}
